import { useEffect, useRef } from 'react'

/**
 * Custom hook that creates a setInterval with automatic cleanup.
 * Based on https://usehooks-ts.com/react-hook/use-interval
 *
 * @param callback - Function to call on each interval
 * @param delay - Delay in milliseconds, or null to pause
 */
export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback)

  // Remember the latest callback if it changes.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    // Don't schedule if no delay is specified.
    if (delay === null) {
      return
    }

    const id = setInterval(() => savedCallback.current(), delay)

    return () => clearInterval(id)
  }, [delay])
}
